import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.css']
})
export class SocialMediaComponent implements OnInit {
  @Input() color:string = '#334e85'
  @Input() size:number = 35;
  
  constructor() { }

  ngOnInit() {
  }

}
